import { defineProperty as _defineProperty } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { cssClassPrefix } from '../../../shared/constants/generalConstants.js';
import { isEnterKeyPressed, isSpaceKeyPressed } from '../../../shared/utils/keysUtils.js';

var BASE_CSS = "".concat(cssClassPrefix, "-footer__item");
var IlFooterItem = function IlFooterItem(props) {
  var title = props.title,
    label = props.label,
    onClick = props.onClick;

  // Accessibility - @TODO Remove with SO-288
  var onKeyPressHandler = function onKeyPressHandler(e) {
    if (isEnterKeyPressed(e) || isSpaceKeyPressed(e)) {
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("li", {
    className: BASE_CSS
  }, label && /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(BASE_CSS, "-label")
  }, label), /*#__PURE__*/React__default.createElement("span", {
    role: "button",
    className: classNames("".concat(BASE_CSS, "-title"), _defineProperty({}, "".concat(BASE_CSS, "--clickable"), onClick)),
    onClick: onClick || null,
    onKeyPress: onKeyPressHandler,
    tabIndex: 0
  }, title));
};
IlFooterItem.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  label: PropTypes.string
};

export { IlFooterItem as default };
